import { isIOS } from "../platform.js";
import { findClosestScrollableContainer } from "../dom/index.js";
import lockSafariScroll from "./lockSafari.js";
import lockStandardScroll from "./lockStandard.js";
let bodyLockedCount = 0;
export const lockScroll = (args) => {
    const isIOSLock = isIOS();
    let reset = () => { };
    let container = document.body;
    if (args.originEl)
        container = findClosestScrollableContainer({ el: args.originEl });
    if (args.containerEl)
        container = args.containerEl;
    const lockedBodyScroll = container === document.body;
    if (lockedBodyScroll)
        bodyLockedCount += 1;
    if (lockedBodyScroll && bodyLockedCount > 1)
        return;
    if (isIOSLock && lockedBodyScroll) {
        reset = lockSafariScroll();
    }
    else {
        reset = lockStandardScroll({ container });
    }
    args.cb?.();
    return (cb) => {
        if (lockedBodyScroll)
            bodyLockedCount -= 1;
        reset();
        cb?.();
    };
};
